import { features } from '@/mocks/home';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-950 font-heading mb-3">
            本站优势
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-[600px] mx-auto">
            为什么选择51爆料网？五大核心优势告诉你答案
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {features.map((feature) => (
            <div
              key={feature.id}
              className="bg-background-50 rounded-xl p-6 border border-background-200/70 text-center group hover:scale-[1.02] transition-transform"
            >
              <div className="w-14 h-14 rounded-2xl bg-primary-100 flex items-center justify-center mx-auto mb-4">
                <i className={`${feature.icon} text-primary-600 text-2xl w-6 h-6 flex items-center justify-center`}></i>
              </div>
              <h3 className="font-bold text-foreground-900 text-base mb-2">{feature.title}</h3>
              <p className="text-foreground-600 text-sm leading-relaxed">{feature.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}